import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHandler, HttpHeaders, HttpResponse } from '@angular/common/http';
import { MetadataDto } from './metadatadto';
import { MetadataPackageDto } from './metadatapackagedto';
import { Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ProjectOptions } from './projectOptions';

@Injectable()
export class GSPMetadataService {
  public selectPath: string;
  public selectType: string;
  public sessionId: string;
  // 环境变量
  private SERVER_IP: string;
  private METADATA_BASE_PATH = '/api/dev/main/v1.0/metadatas';
  private GSP_PROJECT_BASE_PATH = '/api/dev/main/v1.0/gsp-projects';
  private Project_Base_Path = '/api/dev/main/v1.0/project';
  private DBO_BASE_PATH = '/api/dev/main/v1.0/database-objects';  // dbo相关
  private METADATA_PROJECT_BASE_PATH = '/api/dev/main/v1.0/metadata-projects';
  private METADATA_PACKAGE_BASE_PATH = '/api/dev/main/v1.0/metadata-packages';
  private METADATA_CONFIG_BASE_PATH = '/api/dev/main/v1.0/metadata-configs';
  // private Metadata4RefDto_Base_Path = '/api/dev/main/v1.0/metadata4refdtos'; pickMetadataIndex，dotnet不需要
  // tslint:disable-next-line:variable-name
  private DevBasinBOInfo_Base_Path = '/api/dev/main/v1.0/dev-basic-boinfos'; // 业务对象
  private NUGET_BASE_PATH = '/api/dev/main/v1.0/nuget-packages';
  private SETTING_BASE_PATH = '/api/dev/main/v1.0/ide/settings';
  private MAVEN_JAVA_BASE_PATH = '/api/dev/main/v1.0/repo-packages';
  private FS_JAVA_BASE_PATH = '/api/dev/main/v1.0/file-system';
  private JAVA_CODE_GENERATOR = '/api/dev/main/v1.0/generator';
  private JAVA_BUILD = '/api/dev/main/v1.0/repo-packages';

  private METADATA_JAVA_BASE_PATH = '/api/dev/main/v1.0/mdservice';

  constructor(private http: HttpClient, @Inject('url') private url: string) {
    this.SERVER_IP = (url === null || url === undefined) ? '' : url;
    this.sessionId = gsp.cache.get('sessionId');
  }

  /**
   * 元数据设计时服务
   */

  // 打包（功能触发）
  public Pack() {
    if (this.selectType === 'folder' || this.selectType === 'project') {
      if (this.selectPath !== '' && this.selectPath !== undefined) {
        this.PackageBuild(this.selectPath.substring(1));
      }
    } else {
      alert('请选择合适的目录');
    }
  }

  // 打包（外部调用）
  public PackageBuild(path: string): Observable<any> {
    const sessionId = gsp.cache.get('sessionId');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' }).append('SessionId', sessionId);
    const packageDto = new MetadataPackageDto('', '', '', path);
    const url = this.SERVER_IP + this.METADATA_PACKAGE_BASE_PATH;
    return this.http.post(url, packageDto, {
      headers,
      observe: 'response'
    });
  }

  // 递归查找是否存在工程文件
  public IsProjExistRecursively(path: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '/validationrecursively?path=' + path;
    const metadata = new Subject<any>();
    this.http.get(url).subscribe(
      result => {
        // if (result) {
        metadata.next(result);
        // }
      });
    return metadata;
  }

  // 初始化元数据实体
  public InitializeMetadataEntity(metadataDto: MetadataDto): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);

    let name_chs = metadataDto.name;
    let name_en ="";
    let name_cht ="";
    if(metadataDto.nameLanguage) {
      name_chs = metadataDto.nameLanguage['zh-CHS']?metadataDto.nameLanguage['zh-CHS']:"";
      name_en = metadataDto.nameLanguage['en']?metadataDto.nameLanguage['en']:"";
      name_cht = metadataDto.nameLanguage['zh-CHT']?metadataDto.nameLanguage['zh-CHT']:"";
    }
    // tslint:disable-next-line:max-line-length
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/initialized?nameSpace=' + metadataDto.nameSpace + '&code=' + metadataDto.code + '&name=' + name_chs + '&name_cht=' + name_cht + '&name_en=' + name_en + '&type=' + metadataDto.type + '&bizObjectID=' + metadataDto.bizobjectID + '&metadataPath=' + metadataDto.relativePath + '&extendProperty=' + metadataDto.extendProperty;

    return this.http.get(url, { headers });
  }

  // 新建元数据
  public CreateMetadata(metadataDto: MetadataDto): Observable<any> {
    const content = {
      'ID': metadataDto.id,
      'NameSpace': metadataDto.nameSpace,
      'Code': metadataDto.code,
      'Name': metadataDto.name,
      'FileName': metadataDto.fileName,
      'RelativePath': metadataDto.relativePath,
      'Content': metadataDto.content,
      'Type': metadataDto.type,
      'BizobjectID': metadataDto.bizobjectID,
      'ExtendProperty': metadataDto.extendProperty,
      'NameLanguage': !metadataDto.nameLanguage ? null : metadataDto.nameLanguage,
      'Properties': metadataDto.properties
    };
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_BASE_PATH;

    return this.http.post(url, content, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  // 删除元数据文件
  public DeleteMetadata() {
    if (this.selectPath !== '' && this.selectPath !== undefined) {
      if (this.selectType === 'file') {
        this.DeleteMetadataOrDir(this.selectPath.substring(1)).subscribe(result => {
          // 刷新节点
          // this.treeModel.removeFileNode();
          alert('删除成功！');
          this.selectPath = '';
          this.selectType = '';
        }, error => {
          alert('删除失败！');
        });
      } else {
        alert('请选择正确的文件进行删除！');
      }
    } else {
      alert('请选择正确的文件进行删除！');
    }
  }

  // 保存元数据
  public SaveMetadata(metadataDto: MetadataDto, sessionId: string): Observable<any> {
    const content = {
      'ID': metadataDto.id,
      'NameSpace': metadataDto.nameSpace,
      'Code': metadataDto.code,
      'Name': metadataDto.name,
      'FileName': metadataDto.fileName,
      'RelativePath': metadataDto.relativePath,
      'Content': metadataDto.content,
      'Type': metadataDto.type,
      'BizobjectID': metadataDto.bizobjectID,
      'ExtendProperty': metadataDto.extendProperty,
      'Extendable': metadataDto.extendable,
      'NameLanguage': !metadataDto.nameLanguage ? null : metadataDto.nameLanguage,
      'Properties': metadataDto.properties
    };
    // tslint:disable-next-line:one-variable-per-declaration
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_BASE_PATH;

    return this.http.put(url, content, {
      headers,
      observe: 'response'
    });
  }

  // Load元数据（外部调用）
  public LoadMetadata(fullName: string, path: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const metadataFullPath = path.replace(/\\/g, '/') + '/' + fullName;
    const encMetadataFullPath = encodeURIComponent(metadataFullPath);
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/load?metadataFullPath=' + encMetadataFullPath;
    return this.http.get(url, { headers });
  }

  // Load bo内元数据（外部调用）
  public LoadMetadataInBo(fullName: string, path: string, currentProjPath: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const metadataFullPath = path.replace(/\\/g, '/') + '/' + fullName;
    const encMetadataFullPath = encodeURIComponent(metadataFullPath);
    // tslint:disable-next-line: max-line-length
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/metadataInBo?metadataFullPath=' + encMetadataFullPath
      + '&currentProjPath=' + currentProjPath;
    return this.http.get(url, { headers });
  }

  // 删除文件夹
  public DeleteFolder() {
    if (this.selectPath !== '' && this.selectPath !== undefined) {
      if (this.selectType === 'folder') {
        this.DeleteMetadataOrDir(this.selectPath.substring(1)).subscribe(result => {
          // 刷新节点
          // this.treeModel.removeFolderNode();
          alert('删除成功！');
          this.selectPath = '';
          this.selectType = '';
        }, error => {
          alert('删除失败！');
        });
      } else {
        alert('请选择正确的目录进行删除！');
      }
    } else {
      alert('请选择正确的目录进行删除！');
    }
  }

  // 删除工程
  public DeleteProj() {
    if (this.selectPath !== '' && this.selectPath !== undefined) {
      if (this.selectType === 'project') {
        this.DeleteProject(this.selectPath.substring(1)).subscribe(result => {
          // 刷新节点
          // this.treeModel.removeProjectNode();
          alert('删除成功！');
          this.selectPath = '';
          this.selectType = '';
        }, error => {
          alert('删除失败！');
        });
      } else {
        alert('请选择正确的工程节点进行删除！');
      }
    } else {
      alert('请选择正确的工程节点进行删除！');
    }
  }

  // 元数据或者文件夹的删除（外部调用）
  public DeleteMetadataOrDir(fullPath: string): Observable<any> {
    const sessionId = gsp.cache.get('sessionId');
    const headers = new HttpHeaders().set('SessionId', sessionId);
    const encFullPath = encodeURIComponent(fullPath.replace(/\\/g, '/'));
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/delete?fullPath=' + encFullPath;

    return this.http.delete(url, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  // 判断元数据是否被依赖
  public isMetadataRefed(fullPath: string): Observable<any> {
    const sessionId = gsp.cache.get('sessionId');
    const headers = new HttpHeaders().set('SessionId', sessionId);
    const encFullPath = encodeURIComponent(fullPath.replace(/\\/g, '/'));
    const url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '/isMetadataRefed?path=' + encFullPath;

    return this.http.get(url, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  // 删除工程
  public DeleteProject(path: string): Observable<any> {
    const sessionId = gsp.cache.get('sessionId');
    const headers = new HttpHeaders().set('SessionId', sessionId);
    const url = this.SERVER_IP + this.Project_Base_Path + '/' + path.replace(/\\/g, '/');
    return this.http.delete(url, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  public GetDevRootPath(): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const options = {
      params: {},
      headers,
      responseType: 'text'
    };
    const url = this.SERVER_IP + this.Project_Base_Path + '/rootpath';
    const metadata = new Subject<any>();
    this.http.get(url, { responseType: 'text' }).subscribe(
      result => {
        if (result) {
          metadata.next(result);
        }
      });
    return metadata;
  }

  public LoadDBO(fullName: string, path: string, sessionId: string): Observable<any> {
    const dboFullPath = path.replace(/\\/g, '/') + '/' + fullName;
    const url = this.SERVER_IP + this.DBO_BASE_PATH + '/' + dboFullPath;

    const headers = new HttpHeaders().set('SessionId', this.sessionId);

    return this.http.get(url, { headers });
  }

  // 新建文件夹
  public CreateDir(path: string, name: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.Project_Base_Path + '/folder' + path + '/' + name + '?quiet=true';

    return this.http.post(url, null, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  // 获取元数据工程信息
  public GetProjectInfo(path: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '?path=' + path;

    return this.http.get(url, { headers });
  }

  // 获取元数据选择器上的分类
  public GetClassifier(): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/classifier';
    return this.http.get(url, { headers });
  }

  // 获取工程信息
  public GetGspProjInfo(path: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.GSP_PROJECT_BASE_PATH + '?path=' + path;

    return this.http.get(url, { headers });
  }

  // 获取工程路径
  public GetProjPath(path: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '/path?path=' + path;

    return this.http.get(url, { responseType: 'text' });
  }

  // 获取当前工程下或者其他元数据包中依赖的元数据
  public GetRefMetadata(path: string, metadataid: string, sessionId: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/relied?metadataPath=' + path + '&metadataID=' + metadataid;

    return this.http.get(url, { headers });
  }

  // 获取当前工程下或者其他元数据包中依赖的元数据
  public GetRefMetadataBySemantic(path: string, metadataid: string, namespace: string, code: string, type: string,
                        sourceMetadataid:string, sourceNamespace: string, sourceCode: string, sourceType: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/reliedBySemantic?metadataPath=' + path
                        + '&metadataID=' + metadataid + '&namespace=' + namespace + '&code=' + code + '&type=' + type
                        + '&sourceMetadataID=' + sourceMetadataid + '&sourceNamespace=' + sourceNamespace + '&sourceCode=' + sourceCode + '&sourceType=' + sourceType;

    return this.http.get(url, { headers });
  }

  // 获取当前工程下所有的元数据包
  GetMetadataList(spacePath: string, typeName: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '?path=' + spacePath + '&metadataTypeList=' + typeName;

    return this.http.get(url, { headers });
  }

  // 获取bo工程下所有的元数据列表
  GetMetadataListInBo(projPath: string, typeName: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '/metadataListInBo?path=' + projPath + '&metadataTypeList=' + typeName;
    return this.http.get(url, { headers });
  }

  GetMetadataByFilter(path: string, typeCode: string, filter: string, postfix: string) {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/filter?path=' + path +
      '&typeCode=' + typeCode + '&filter=' + filter + '&postfix=' + postfix;

    return this.http.get(url, { headers });
  }

  pickMetadataIndex(scope: number, currentProjPath: string, metadataIndexDto: any): Observable<any> {
    const sessionId = gsp.cache.get('sessionId');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' }).append('SessionId', sessionId);
    const url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '/pickmd?scopeType=' + scope + '&currentPath=' + currentProjPath;
    return this.http.post(url, metadataIndexDto, {
      headers
    });
  }

  // 获取元数据包中所包含的元数据信息
  GetMetadataPackageInfo(packagePath: string, packageName: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    let packageFullName = '';
    if (packagePath) {
      packageFullName = packagePath.replace(/\\/g, '/') + '/' + packageName;
    } else {
      packageFullName = packageName;
    }
    const encPackageFullName = encodeURIComponent(packageFullName);
    const url = this.SERVER_IP + this.METADATA_PACKAGE_BASE_PATH + '/packagePath?packagePath=' + encPackageFullName;

    return this.http.get(url, { headers });
  }

  // 获取本地包
  GetLocalPackages(path: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_PACKAGE_BASE_PATH + '/local?path=' + path;

    return this.http.get(url, { headers });
  }

  GetMetadataInfosByScope(scope: number, metadataType = null, searchText = null, page = null,
    selectedPackageSource = null, currentProjPath = '') {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    let url = this.SERVER_IP + this.METADATA_BASE_PATH + '/scope/' + scope + '?path=' + currentProjPath;
    if (page) {
      url = url + '&page=true&pageIndex=' + page.pageIndex + '&pageSize=' + page.pageSize;
    } else {
      url = url + '&page=false';
    }
    if (metadataType) {
      url = url + '&metadataTypeList=' + metadataType;
    }
    if (searchText) {
      url = url + '&text=' + searchText;
    }
    if ((scope === 2 || scope === 3) && selectedPackageSource) {
      url = url + '&selectedPackageSource=' + selectedPackageSource;
    }
    return this.http.get(url, { headers });
  }

  GetMetadataInfosByScope4Java(scope: number, metadataType = null, searchText = null, page = null,
    selectedPackageSource = null, currentProjPath = '') {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    let url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '/mdlist?scopeType=' + scope + '&path=' + currentProjPath;
    if (page) {
      url = url + '&page=true&pageIndex=' + page.pageIndex + '&pageSize=' + page.pageSize;
    } else {
      url = url + '&page=false';
    }
    if (metadataType) {
      url = url + '&metadataTypeList=' + metadataType;
    }
    if (searchText) {
      url = url + '&text=' + searchText;
    }
    if ((scope === 2 || scope === 3) && selectedPackageSource) {
      url = url + '&selectedPackageSource=' + selectedPackageSource;
    }
    return this.http.get(url, { headers });
  }

  // 获取某个路径下的所有元数据包
  GetMetadataPackages(path: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.Project_Base_Path + '/children/' + path;

    return this.http.get(url, { headers });
  }

  // 获取元数据类型及后缀信息
  GetMetadataTypeList(): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_CONFIG_BASE_PATH;

    return this.http.get(url, { headers });
  }

  // 获取后缀
  GetPostfix(metadataType): Observable<any> {
    this.GetMetadataTypeList().subscribe(typeList => {
      typeList.forEach(type => {
        if (metadataType.toLowerCase() === type.typeCode.toLowerCase()) {
          return type.postfix;
        }
      });
    });
    return new Observable<any>();
  }

  // 更新工程引用
  UpdateMetadataProject(projectPath: string, packageHeader: any): Observable<any> {
    const content = {
      ProjectPath: projectPath,
      DepPackageName: packageHeader.name,
      DepPackageVersion: packageHeader.version.versionString,
      DepPackageLocation: packageHeader.location
    };
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH;

    return this.http.put(url, content, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  // 根据业务对象ID获取app、su等信息
  GetDevBasicBOInfo(businessObjectID: string, sessionId: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.DevBasinBOInfo_Base_Path + '/' + businessObjectID;

    return this.http.get(url, { headers });
  }

  ValidateRepeatName(path: string, fileName: string) {
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/validation?path=' + path + '&fileName=' + fileName;

    const metadata = new Subject<any>();
    this.http.get(url).subscribe(
      result => {
        // if (result) {
        metadata.next(result);
        // }
      });
    return metadata;
  }

  SetMetadataUri(path: string, sessionId: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_CONFIG_BASE_PATH + '?path=' + path;
    return this.http.put(url, null, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  getGspProjectType(): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.GSP_PROJECT_BASE_PATH + '/type';

    return this.http.get(url, { headers });
  }

  updateGspProject(path: string, codeLanguage: string): Observable<any> {
    const sessionId = gsp.cache.get('sessionId');
    const headers = new HttpHeaders().set('SessionId', sessionId);
    const url = this.SERVER_IP + this.GSP_PROJECT_BASE_PATH + '?path=' + path + '&codeLanguage=' + codeLanguage;

    return this.http.put(url, null, {
      params: {},
      headers,
      observe: 'response'
    });
  }

  getNugetSourceList(): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.NUGET_BASE_PATH + '/sources';

    return this.http.get(url, { headers });
  }

  getMavenSourceList(): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.MAVEN_JAVA_BASE_PATH + '/repolist';

    return this.http.get(url, { headers });
  }

  // 获取技术栈
  // tslint:disable-next-line:adjacent-overload-signatures
  public getCodeLanguage(projPath: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '/codelanguage?projPath=' + projPath;
    return this.http.get(url, { responseType: 'text' });
  }

  // 获取setting信息
  public getSettingInfo(): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.SETTING_BASE_PATH;
    return this.http.get(url, { headers });
  }

  // 是否开启maven
  public getMavenSetting(): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_BASE_PATH + '/mavensetting';
    return this.http.get(url);
  }

  // 获取bo路径
  public getBoPath(path: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '/bopath?path=' + path;
    return this.http.get(url, { responseType: 'text' });
  }

  // 获取是否是maven引用
  public getMavenStatus(path: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '/isMaven?path=' + path;
    return this.http.get(url);
  }

  // 获取是否是解析型工具
  public isInterpretation(path: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '/isInterpretation?path=' + path;
    return this.http.get(url);
  }

  // 生成代码
  generate(path: string): Observable<any> {
    const url = this.JAVA_CODE_GENERATOR + '?path=' + path;
    return this.http.post(url, null);
  }

  // 获取ProcessMode
  public getProcessMode(path: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '/processMode?path=' + path;
    return this.http.get(url, { responseType: 'text' });
  }

  // 添加依赖并更新版本
  public addDependencyAndRestore(path: string, metadataPackages: string, isMaven: boolean): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    let url;
    if (isMaven) {
      url = this.SERVER_IP + this.MAVEN_JAVA_BASE_PATH + '/adddepedency?path=' + path
        + '&metadataPackages=' + metadataPackages;
      return this.http.put(url, null, {
        params: {},
        headers,
        observe: 'response'
      });
    } else {
      url = this.SERVER_IP + this.NUGET_BASE_PATH + '/adddepedency?projPath=' + path
        + '&metadataPackages=' + metadataPackages;
      return this.http.post(url, null, {
        params: {},
        headers,
        observe: 'response'
      });
    }
  }

  // 在资源管理器中打开
  public showInExplorer(path: string): Observable<any> {
    const url = this.SERVER_IP + this.FS_JAVA_BASE_PATH + '?path=' + path;
    return this.http.get(url);
  }

  public restoreMavenPackage(path: string, metadataPackages: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.MAVEN_JAVA_BASE_PATH + '/adddepedency?path=' + path + '&metadataPackages=' + metadataPackages;
    return this.http.put(url, null, {
      headers,
      observe: 'response'
    });
  }

  // 获取菜单
  public getMenu(path: string): Observable<any> {
    const url = this.SERVER_IP + this.SETTING_BASE_PATH + '/menu?path=' + path;
    return this.http.get(url);
  }

  mavenBuildAll(projPath: string, fakeFlag: boolean = false): Observable<any> {
    if (fakeFlag) {
      return this.getMenu(projPath);
    }
    const url = this.JAVA_BUILD + '/compileAll?path=' + projPath;
    return this.http.post(url, null);
  }

  // 获取路径下的工程路径
  public getProjPathsInPath(path: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '/projinpath?path=' + path;
    return this.http.get(url);
  }



  public getMdpkgNameExistInBo(path: string, mdpkgName: string) {
    const url = this.SERVER_IP + this.METADATA_JAVA_BASE_PATH + '/mdpkgNameExist?path=' + path + '&mdpkgName=' + mdpkgName;
    return this.http.get(url, { responseType: 'text' });
  }

  // 是否存在工程文件，废弃，使用getProjPath代替
  public IsProjExist(path: string): Observable<any> {
    const url = this.SERVER_IP + this.METADATA_PROJECT_BASE_PATH + '/validation?path=' + path;
    const metadata = new Subject<any>();
    this.http.get(url).subscribe(
      result => {
        metadata.next(result);
      });
    return metadata;
  }

  // 获取Nuget包下所有的元数据包，nuget已废弃
  GetMetadataPackagesUnderNugetDir(path: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.METADATA_PACKAGE_BASE_PATH + '?path=' + path;

    return this.http.get(url, { headers });
  }

  getMetadataTypeWithProjectDtoMap(boPath: string): Observable<any> {
    const headers = new HttpHeaders().set('SessionId', this.sessionId);
    const url = this.SERVER_IP + this.GSP_PROJECT_BASE_PATH + '/type2project?boPath=' + boPath;
    return this.http.get(url, { headers });
  }

  // 新建工程
  public createProject(options: ProjectOptions) {
    const content = {
      type: options.type,
      attributes: options.attributes,
      path: options.path,
      description: options.description,
      name: options.name
    };
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'as');
    headers.append('Access-Control-Allow-Origin', '*');
    const resOptions = {
      params: {},
      headers
    };
    const url = this.SERVER_IP + '/api/dev/main/v1.0/project?name=' + options.name + '&nameSpace=' + options.nameSpace +
      '&packageName=' + options.packageName + '&targetFramework=' + options.targetFramework + '&conditionRelease=' +
      options.conditionRelease + '&conditionDebug=' + options.conditionDebug + '&outputPath=' + options.outputPath +
      '&boid=' + options.boID + '&appCode=' + options.appCode + '&suCode=' + options.suCode + '&boCode=' +
      options.boCode + '&suDeploymentPath=' + options.suDeploymentPath + '&projType=' + options.projType + '&override=' +
      options.override + '&codelanguage=' + options.codelanguage + '&processMode=' + options.processMode;
    return this.http.post(url, content, resOptions);
  }
}


